import { useEffect, useState } from "react";
import { api } from "../api";

let cachedLogoVersion: string | null | undefined;
const subscribers = new Set<(version: string | null) => void>();
function loadLogoVersion(): void {
  api.branding().then((info) => { cachedLogoVersion = info.logoVersion; subscribers.forEach((notify) => notify(info.logoVersion)); }).catch(() => { cachedLogoVersion = null; subscribers.forEach((notify) => notify(null)); });
}
export function refreshBranding(): void { loadLogoVersion(); }

export function BrandMark() {
  const [logoVersion, setLogoVersion] = useState<string | null | undefined>(cachedLogoVersion);
  useEffect(() => {
    subscribers.add(setLogoVersion);
    if (cachedLogoVersion === undefined) loadLogoVersion(); else setLogoVersion(cachedLogoVersion);
    return () => { subscribers.delete(setLogoVersion); };
  }, []);
  return <div className="brand" aria-label="Talahwa home">
    {logoVersion
      ? <img className="brand-logo" src={api.brandingLogoUrl(logoVersion)} alt="" />
      : <span className="brand-mark" aria-hidden="true"><i /><i /><i /></span>}
    <span>TALA<span>HWA</span></span>
  </div>;
}
